export const seriesName = {
  [1]: '小智报表-展示端',
  [2]: '小智报表-设计器',
  [101]: '小智BI-展示端',
  [102]: '小智BI-设计器',
  [201]: '小智API服务',
};

export const version = {
  [1]: '免费版',
  [2]: '标准版',
  [3]: '高级版',
  [4]: '旗舰版',
};

export const getseriesNameOption = () => {
  let seriesNameOption = [];

  for (const key in seriesName) {
    seriesNameOption.push({
      name: seriesName[key],
      value: Number(key),
    });
  }
  return seriesNameOption;
};

export const getVersionOption = (needAll = false) => {
  let versionOption = [];

  for (const key in version) {
    versionOption.push({
      name: version[key],
      value: Number(key),
    });
  }

  if (!needAll) {
    /* 去除免费版 */
    versionOption = versionOption.filter((i) => i.value !== 1);
  }

  return versionOption;
};

export const getUpgradeVersion = (version) => {
  const result = [];
  for (const key in version) {
    if (key > version) {
      result.push({ name: version[key], value: Number(key) });
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/components/xzReport/utils.js